import { type FC, memo, useEffect } from 'react';
import styles from './wallet-connected.module.scss';
import Dropdown from '@ui/dropdown';
import arrowIcon from '@assets/images/icons/arrow-down.svg';
import { useToggle } from 'react-use';

import { useCurrentAccount, useCurrentWallet, useDisconnectWallet } from '@mysten/dapp-kit';
import WalletList from './wallet-list';
import { useAddressDomain } from '@hooks/use-address-domain';
import { formatAddress } from '@utils/format-address';
import { deepbook } from '@libs/deepbook';
import { forEacGetOwnedObjects } from '@utils/sui-kit';
import { config } from '@config';
import { useRefreshFlag } from '@hooks/use-refresh';

const WalletConnected: FC = () => {
  const currentAccount = useCurrentAccount();
  const wallet = useCurrentWallet();
  const [domain] = useAddressDomain(currentAccount?.address || '');
  const [showMenu, toggleShowMenu] = useToggle(false);
  const { mutate: disconnect } = useDisconnectWallet();
  const { refresh, notifyRefresh } = useRefreshFlag();

  useEffect(() => {
    // Disconnect from wallet extension
    !currentAccount && disconnect();
  }, [!!currentAccount]);

  const updateAddress = async () => {
    if (currentAccount) {
      let balanceManagerAddress =
        localStorage.getItem(`Turbos_Balance_Manager_${currentAccount.address}`) || '';

      if (!balanceManagerAddress) {
        const objects = await forEacGetOwnedObjects<{
          balance_manager_id: string;
          id: {
            id: string;
          };
        }>(currentAccount.address, {
          StructType: `${config.deepbook_package_id}::balance_manager::TradeCap`,
        });

        if (objects.length > 0 && objects[0]?.balance_manager_id) {
          balanceManagerAddress = objects[0].balance_manager_id;
        }
      }
      if (deepbook.getBalanceManagerAddress() !== balanceManagerAddress) {
        deepbook.updateAddress(currentAccount.address, balanceManagerAddress);
        notifyRefresh(1000);
      }
    } else {
      deepbook.updateAddress('', '');
    }
  };

  useEffect(() => {
    updateAddress();
  }, [currentAccount, refresh, deepbook]);

  return (
    <Dropdown
      onVisibleChange={toggleShowMenu}
      placement="bottomRight"
      overlay={<WalletList />}
      onOverlayClick={toggleShowMenu}
    >
      <div className={`${styles.button} ${showMenu ? styles.active : ''}`} key="connected">
        <img src={wallet.currentWallet?.icon} className={styles.wallet_icon} />
        <span>
          {formatAddress({
            domain,
            label: currentAccount?.label,
            address: currentAccount?.address,
          })}
        </span>
        <img src={arrowIcon} className={styles.arrow_icon} />
      </div>
    </Dropdown>
  );
};

export default memo(WalletConnected);
